import React, { useEffect, useState, useCallback, memo } from 'react';
import './singleactivitytab.css';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useAuth } from '../../../firebase/AuthProvider';
import { PaginatedTaskActionsResponse, TaskAction, TaskActionFilterParams } from '../../../interfaces/participant/ParticipantTask';
import { getTaskActionsByParticipant } from '../../../services/participantServices/ParticipantDataService';

const Singleactivitytab: React.FC = () => {
    const { currentUser } = useAuth();
    const { id: participantId } = useParams<{ id: string }>();

    const [activities, setActivities] = useState<PaginatedTaskActionsResponse | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    
    const fetchActivities = useCallback(async () => {
        if (!currentUser || !participantId) return;

        setLoading(true);
        try {
            const token = await currentUser.getIdToken();
            const numericParticipantId = parseInt(participantId, 10);

            if (isNaN(numericParticipantId)) {
                toast.error("Invalid participant ID.");
                setLoading(false);
                return;
            }

            const filterParams: TaskActionFilterParams = {
                pageNumber: 1,
                pageSize: 5, // Fetch only 5 for the preview
                sortBy: 'createDate',
                sortOrder: 'desc',
            };

            const response = await getTaskActionsByParticipant(numericParticipantId, token, filterParams);
            setActivities(response);

        } catch (error: any) {
            toast.error(error.message || "Failed to fetch activities.");
        } finally {
            setLoading(false);
        }
    }, [currentUser, participantId]);

    useEffect(() => {
        fetchActivities();
    }, [fetchActivities]);

    return (
        <>
            <div className="common_content_inner mby_t_24">
                {loading ? (
                    <div className="text-center">Loading activities...</div>
                ) : !activities || activities.items.length === 0 ? (
                    <div className="text-center">No activities found.</div>
                ) : (
                    <div className="task_activity_grid single_activity_grid">
                        {activities.items.map((activity: TaskAction) => (
                            <div className="task_activity_card" key={activity.id}>
                                <div className="task_activity_card_top">
                                    <h2>{activity.author ? `${activity.author.firstName} ${activity.author.lastName}` : 'System'}</h2>
                                    <div className="date_edit">
                                        <p>{moment(activity.createDate).format('MM/DD/YYYY h:mm A')}</p>
                                    </div>
                                </div>
                                <div className="task_activity_card_btm">
                                    <p>{activity.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default memo(Singleactivitytab);
